var CountUpBox = (function($) {

  var _s = {
    container: '.chm-block-countup-box',
    number: '.chm-block-countup-box__number'
  };

  var _init = function() {
    _bindEvents();
  };

  var _bindEvents = function() {

    $(_s.number).each(function() {
      let num = $(this).data('number');
      console.log(num);

      new countUp.CountUp(this, num, {
        enableScrollSpy: true,
        duration:3,
      });
      // anim.start(); // not need if enableScrollSpy is true
    });

  };

  return {
    init: _init
  };

})(jQuery);